import { render, staticRenderFns } from "./status.vue?vue&type=template&id=506b13da&"
import script from "./status.vue?vue&type=script&lang=js&"
export * from "./status.vue?vue&type=script&lang=js&"
import style0 from "./status.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports